import React from 'react';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../../fx/FxLog';
import * as FxFetch from '../../../fx/FxFetch';
import { useTranslation } from '../../../hx/useTranslation';
import CxDialog from '../../../cx/CxDialog';
import CxInput from '../../../cx/CxInput';
import CxSnackbar from '../../../cx/CxSnackbar';
import CxDlgAlert from '../../../cx/CxDlgAlert'; // Importación para el bloqueo
import '../../../../styles/main.css';


const MxTypeOTF = (props) => {
  const [{ trans }] = useTranslation();
  const [dlg, setDlg] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);

  const rf_txType = React.useRef(null);

  const r_dlg_alert = React.useRef(null); // Referencia para la alerta de espera
  const r_snack_required = React.useRef(null);
  const r_snack_exists = React.useRef(null);

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  // para poder usar setVal desde el parent component con ref.current
  React.useImperativeHandle(props.xref, () => {
    return {
      setDlg,
    };
  });

  const formLoad = async () => {
  }

  const formSave = async () => {
    // chequea requeridos
    if (rf_txType.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txType.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }

    // --- PROCESO DE GUARDADO ---
    setDlg(false); // Cerramos el diálogo principal
    setDisabled(true);

    r_dlg_alert.current.setText(trans('msg.saving'));
    r_dlg_alert.current.setProgressMsg(trans('msg.please_wait'));
    r_dlg_alert.current.setTextColor('var(--ibs_color_blue)');
    r_dlg_alert.current.setHasButtonClose(false);
    r_dlg_alert.current.setOpen(true);

    let txTypeXXX = rf_txType.current.getVal();
  
    let record = {};
    record['txType'] = txTypeXXX;
    if (props.parent) {
      record['itXXX_related'] = props.parent.current.getKey();
    }

    Promise.all([FxFetch.doJsonX(props.url, record)]).then((result) => {
      r_dlg_alert.current.setOpen(false); // Cerramos alerta de espera

      if (result[0]) {
        if (result[0].theValue === "rv_type_exists") {
          // El tipo ya existe: reabrimos formulario
          setDisabled(false);
          setDlg(true);
          r_snack_exists.current.setVal(trans('msg.x_exists', props.name));
          r_snack_exists.current.setOpen(true);
        } else {
          // ÉXITO: Sin snackbar, notificamos al padre y desbloqueamos
          let itXXX = result[0].theValue;
          if (props.onOk) props.onOk(itXXX, txTypeXXX);
          setDisabled(false);
        }
      }
    }).catch((error) => {
      // Error de red/servidor: reabrimos formulario
      r_dlg_alert.current.setOpen(false);
      setDisabled(false);
      setDlg(true);
      FxLog.errorx("MxTypeOTF.formSave", error);
    });
  }

  return (
    <div>
      <CxDialog title={trans('field.create_x', props.name)} open={dlg} onOk={formSave} onClose={() => setDlg(false)} >
          <CxInput xref={rf_txType} label={trans(props.name)} disabled={disabled} width='var(--ibs_control_width_md)' maxLength={100} required />
      </CxDialog>

      {/* Alerta de bloqueo */}
      <CxDlgAlert xref={r_dlg_alert} />

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_exists} severity="error" />
    </div>
  );

}

export default MxTypeOTF;